"use client";

import { cn } from "@/utils/helpers";
import Image from "next/image";

interface AvatarCirclesProps {
  numPeople?: number;
  avatarUrls: string[];
  className?: string;
}

const AvatarCircles = ({ numPeople, avatarUrls, className }: AvatarCirclesProps) => {
  return (
    <div className={cn("z-10 flex -space-x-4 rtl:space-x-reverse", className)}>
      {avatarUrls.map((url, index) => (
        <Image
          key={index}
          src={url}
          alt={`Avatar ${index + 1}`}
          width={40}
          height={40}
          priority={true}
          className="rounded-full border-2 border-white dark:border-gray-800"
        />
      ))}
      <a
        className="flex h-10 w-10 items-center justify-center rounded-full border-2 border-white bg-black text-center text-xs font-medium text-white hover:bg-gray-600 dark:border-gray-800 dark:bg-white dark:text-black"
        href=""
      >
        +{numPeople}
      </a>
    </div>
  );
};

export default AvatarCircles;
